<template lang="html">
  <div class="register">
    <MainForm
          :isLoadingRegister="isLoading"
          :isError="errorRegister"
          @activeForm="submitForm" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MainForm from '@/components/signup/customer/MainForm'
// import CompanyDetail from '@/components/signup/customer/CompanyDetail'
// import CompleteAcc from '@/components/signup/customer/CompleteAcc'
// import LogisticDetail from '@/components/signup/customer/LogisticDetail'

export default {
  name: 'asCustomer',
  components: {
    MainForm
    // CompanyDetail,
    // CompleteAcc,
    // LogisticDetail
  },
  data () {
    return {
    }
  },

  computed: {
    ...mapGetters({
      auth: 'register/items',
      errorRegister: 'register/error',
      isLoading: 'register/isLoading'
    })
  },

  methods: {
    submitForm (data) {
      if (data) {
        this.$store.dispatch('register/POST_REGISTER_CUSTOMER', data)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/asCustomer/index.vue